<template id="paths">
  <section>
    <b-card>
      <b-card-title>Paths</b-card-title>
      <b-card-sub-title>
        The top paths over the selected time span.
      </b-card-sub-title>
      <b-card-text>
        <div>
          <b-table
            sticky-header="400px"
            striped
            hover
            fixed
            no-border-collapse
            :items="items"
            :fields="primaryFields"
            show-empty
          >
            <template #cell(showDetails)="row">
              <expand-icon
                class="expandIcon"
                :expanded="row.detailsShowing"
                @click.native="row.toggleDetails"
              />
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-table
                  striped
                  hover
                  sticky-header
                  primary-key="name"
                  :fields="secondaryFields"
                  :items="row.item.paths"
                />
              </b-card>
            </template>

            <template #empty="scope">
              {{ scope.emptyText }}
            </template>
          </b-table>
        </div>
      </b-card-text>
    </b-card>
  </section>
</template>

<script>
import { yearMonthDayFormat } from "../common/time_utils";
import { ExpandIcon } from "./icons";

export default {
  name: "path",
  props: {
    pathData: Array,
  },
  components: { ExpandIcon },
  data() {
    return {
      primaryFields: ["timestamp", { key: "showDetails", label: "" }],
      secondaryFields: [
        "path",
        "title",
        { key: "count", sortable: true },
        { key: "uniques", sortable: true },
      ],
    };
  },
  computed: {
    items: function() {
      if (this.pathData !== null) {
        return this.pathData.map((current) => {
          return {
            timestamp: yearMonthDayFormat(new Date(current.timestamp)),
            paths: current.paths,
          };
        });
      }

      return [];
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "path",
  },
};
</script>

<style scoped>
.expandIcon {
  float: right;
}
</style>
